import {
  FeatureSectionPoints,
  FeatureSectionSimpleListVariation,
  HeroSection
} from "./components/lorgar/index.mjs";
import {
  ContentSectionFootnote,
  CtaSectionBanner,
  FeatureSectionBannerVariation,
  FeatureSectionBenefits,
  FeatureSectionPartners,
  FeatureSectionSimpleListBackground,
  FeatureSectionVideoTabs,
  HeroSectionBanner
} from "./components/prestigio/index.mjs";
import {
  ContentSectionSeo,
  VideoSectionTabs,
  CardSectionCategories,
  FeatureSectionBanner,
  FeatureSectionBullets,
  FeatureSectionCarouselButton,
  FeatureSectionSmallBanners,
  FeatureSectionImagesGrid,
  CardSectionSmallBlocks,
  BlogSectionTextImage,
  ContentSectionTips
} from "./components/canyon/index.mjs";
import {
  BlogSectionSimple,
  CardSectionApps,
  CardSectionAwards,
  CardSectionCatalog,
  CardSectionFlags,
  CardSectionGrid,
  CardSectionShops,
  CardSectionSimple,
  DocumentSectionSimple,
  FaqSectionSimple,
  LogoCloudSectionSimple,
  LogoCloudSectionWithFeatures,
  TeamSectionSimple,
  TestimonialSectionSlider,
  VideoSectionSimple,
  FeatureSectionArticles,
  FeatureSectionCarousel,
  FeatureSectionColumns,
  FeatureSectionInfoBlocks,
  FeatureSectionRecommended,
  FeatureSectionSimple,
  FeatureSectionSimpleList,
  FeatureSectionTextImage,
  HeaderSectionBackground,
  HeaderSectionImage,
  HeaderSectionSimple,
  HeaderSectionWithBanner
} from "./components/sections/index.mjs";
const componentsWithDetails = [
  // BlogSection blocks:
  {
    name: "BlogSectionSimple",
    component: BlogSectionSimple,
    id: "BlogSectionSimple",
    category: "BlogSection",
    presets: ["Default", "GridView", "WithTags"]
  },
  {
    name: "BlogSectionTextImage",
    component: BlogSectionTextImage,
    id: "BlogSectionTextImage",
    category: "BlogSection",
    presets: ["Default", "Download"]
  },
  // CardSection blocks:
  {
    name: "CardSectionApps",
    component: CardSectionApps,
    id: "CardSectionApps",
    category: "CardSection",
    presets: ["Default", "Grid"]
  },
  {
    name: "CardSectionAwards",
    component: CardSectionAwards,
    id: "CardSectionAwards",
    category: "CardSection",
    presets: ["Default", "Grid"]
  },
  {
    name: "CardSectionCatalog",
    component: CardSectionCatalog,
    id: "CardSectionCatalog",
    category: "CardSection",
    presets: ["Default"]
  },
  {
    name: "CardSectionFlags",
    component: CardSectionFlags,
    id: "CardSectionFlags",
    category: "CardSection",
    presets: ["Default"]
  },
  {
    name: "CardSectionGrid",
    component: CardSectionGrid,
    id: "CardSectionGrid",
    category: "CardSection",
    presets: ["Default", "TwoColumns", "WithoutItemsOverlay"]
  },
  {
    name: "CardSectionShops",
    component: CardSectionShops,
    id: "CardSectionShops",
    category: "CardSection",
    presets: ["Default"]
  },
  {
    name: "CardSectionSimple",
    component: CardSectionSimple,
    id: "CardSectionSimple",
    category: "CardSection",
    presets: ["Default", "WithFullImage", "WithSmallCards"]
  },
  {
    name: "CardSectionCategories",
    component: CardSectionCategories,
    id: "CardSectionCategories",
    category: "CardSection",
    presets: ["Default"]
  },
  {
    name: "CardSectionSmallBlocks",
    component: CardSectionSmallBlocks,
    id: "CardSectionSmallBlocks",
    category: "CardSection",
    presets: ["Default"]
  },
  // DocumentSection blocks:
  {
    name: "DocumentSectionSimple",
    component: DocumentSectionSimple,
    id: "DocumentSectionSimple",
    category: "DocumentSection",
    presets: ["Default"]
  },
  // FaqSection blocks:
  {
    name: "FaqSectionSimple",
    component: FaqSectionSimple,
    id: "FaqSectionSimple",
    category: "FaqSection",
    presets: ["Default"]
  },
  // LogoCloudSection blocks:
  {
    name: "LogoCloudSectionSimple",
    component: LogoCloudSectionSimple,
    id: "LogoCloudSectionSimple",
    category: "LogoCloudSection",
    presets: ["Default"]
  },
  {
    name: "LogoCloudSectionWithFeatures",
    component: LogoCloudSectionWithFeatures,
    id: "LogoCloudSectionWithFeatures",
    category: "LogoCloudSection",
    presets: ["Default"]
  },
  // TeamSection blocks:
  {
    name: "TeamSectionSimple",
    component: TeamSectionSimple,
    id: "TeamSectionSimple",
    category: "TeamSection",
    presets: ["Default", "WithLinks"]
  },
  // TestimonialSection blocks:
  {
    name: "TestimonialSectionSlider",
    component: TestimonialSectionSlider,
    id: "TestimonialSectionSlider",
    category: "TestimonialSection",
    presets: ["Default", "WithLinks", "WithoutQuotes"]
  },
  // VideoSection blocks:
  {
    name: "VideoSectionSimple",
    component: VideoSectionSimple,
    id: "VideoSectionSimple",
    category: "VideoSection",
    presets: ["Default", "SingleItem"]
  },
  {
    name: "VideoSectionTabs",
    component: VideoSectionTabs,
    id: "VideoSectionTabs",
    category: "VideoSection",
    presets: ["Default"]
  },
  // FeatureSection blocks:
  {
    name: "FeatureSectionArticles",
    component: FeatureSectionArticles,
    id: "FeatureSectionArticles",
    category: "FeatureSection",
    presets: ["Default", "ImageRatioRectangle", "OnlyText"]
  },
  {
    name: "FeatureSectionCarousel",
    component: FeatureSectionCarousel,
    id: "FeatureSectionCarousel",
    category: "FeatureSection",
    presets: ["Default"]
  },
  {
    name: "FeatureSectionColumns",
    component: FeatureSectionColumns,
    id: "FeatureSectionColumns",
    category: "FeatureSection",
    presets: ["Default"]
  },
  {
    name: "FeatureSectionInfoBlocks",
    component: FeatureSectionInfoBlocks,
    id: "FeatureSectionInfoBlocks",
    category: "FeatureSection",
    presets: ["Default"]
  },
  {
    name: "FeatureSectionRecommended",
    component: FeatureSectionRecommended,
    id: "FeatureSectionRecommended",
    category: "FeatureSection",
    presets: ["Default"]
  },
  {
    name: "FeatureSectionSimple",
    component: FeatureSectionSimple,
    id: "FeatureSectionSimple",
    category: "FeatureSection",
    presets: ["Default"]
  },
  {
    name: "FeatureSectionSimpleList",
    component: FeatureSectionSimpleList,
    id: "FeatureSectionSimpleList",
    category: "FeatureSection",
    presets: ["Default", "WithVideo"]
  },
  {
    name: "FeatureSectionTextImage",
    component: FeatureSectionTextImage,
    id: "FeatureSectionTextImage",
    category: "FeatureSection",
    presets: ["Default", "WithAdaptiveImage", "WithButton"]
  },
  {
    name: "FeatureSectionPoints",
    component: FeatureSectionPoints,
    id: "FeatureSectionPoints",
    category: "FeatureSection",
    presets: ["Default", "WithLinks", "WithIcons"]
  },
  {
    name: "FeatureSectionSimpleListVariation",
    component: FeatureSectionSimpleListVariation,
    id: "FeatureSectionSimpleListVariation",
    category: "FeatureSection",
    presets: ["Default"]
  },
  {
    name: "FeatureSectionBannerVariation",
    component: FeatureSectionBannerVariation,
    id: "FeatureSectionBannerVariation",
    category: "FeatureSection",
    presets: ["Default"]
  },
  {
    name: "FeatureSectionBenefits",
    component: FeatureSectionBenefits,
    id: "FeatureSectionBenefits",
    category: "FeatureSection",
    presets: ["Default"]
  },
  {
    name: "FeatureSectionPartners",
    component: FeatureSectionPartners,
    id: "FeatureSectionPartners",
    category: "FeatureSection",
    presets: ["Default"]
  },
  {
    name: "FeatureSectionSimpleListBackground",
    component: FeatureSectionSimpleListBackground,
    id: "FeatureSectionSimpleListBackground",
    category: "FeatureSection",
    presets: ["Default"]
  },
  {
    name: "FeatureSectionVideoTabs",
    component: FeatureSectionVideoTabs,
    id: "FeatureSectionVideoTabs",
    category: "FeatureSection",
    presets: ["Default"]
  },
  {
    name: "FeatureSectionBanner",
    component: FeatureSectionBanner,
    id: "FeatureSectionBanner",
    category: "FeatureSection",
    presets: ["Default", "MoreThanOneParts"]
  },
  {
    name: "FeatureSectionBullets",
    component: FeatureSectionBullets,
    id: "FeatureSectionBullets",
    category: "FeatureSection",
    presets: ["Default"]
  },
  {
    name: "FeatureSectionCarouselButton",
    component: FeatureSectionCarouselButton,
    id: "FeatureSectionCarouselButton",
    category: "FeatureSection",
    presets: ["Default", "Light", "BgImages"]
  },
  {
    name: "FeatureSectionSmallBanners",
    component: FeatureSectionSmallBanners,
    id: "FeatureSectionSmallBanners",
    category: "FeatureSection",
    presets: ["Default"]
  },
  {
    name: "FeatureSectionImagesGrid",
    component: FeatureSectionImagesGrid,
    id: "FeatureSectionImagesGrid",
    category: "FeatureSection",
    presets: ["Default", "WithVerticalPosition"]
  },
  // HeaderSection blocks:
  {
    name: "HeaderSectionBackground",
    component: HeaderSectionBackground,
    id: "HeaderSectionBackground",
    category: "HeaderSection",
    presets: ["Default", "WithoutBg"]
  },
  {
    name: "HeaderSectionImage",
    component: HeaderSectionImage,
    id: "HeaderSectionImage",
    category: "HeaderSection",
    presets: ["Default", "WithoutBg"]
  },
  {
    name: "HeaderSectionSimple",
    component: HeaderSectionSimple,
    id: "HeaderSectionSimple",
    category: "HeaderSection",
    presets: ["Default", "Plain"]
  },
  {
    name: "HeaderSectionWithBanner",
    component: HeaderSectionWithBanner,
    id: "HeaderSectionWithBanner",
    category: "HeaderSection",
    presets: ["Default", "Inverted"]
  },
  // HeroSection blocks:
  {
    name: "HeroSection",
    component: HeroSection,
    id: "HeroSection",
    category: "HeroSection",
    presets: ["Default", "WithModal"]
  },
  {
    name: "HeroSectionBanner",
    component: HeroSectionBanner,
    id: "HeroSectionBanner",
    category: "HeroSection",
    presets: ["Default"]
  },
  // ContentSection blocks:
  {
    name: "ContentSectionFootnote",
    component: ContentSectionFootnote,
    id: "ContentSectionFootnote",
    category: "ContentSection",
    presets: ["Default"]
  },
  {
    name: "ContentSectionSeo",
    component: ContentSectionSeo,
    id: "ContentSectionSeo",
    category: "ContentSection",
    presets: ["Default"]
  },
  {
    name: "ContentSectionTips",
    component: ContentSectionTips,
    id: "ContentSectionTips",
    category: "ContentSection",
    presets: ["Default"]
  },
  // CtaSection blocks:
  {
    name: "CtaSectionBanner",
    component: CtaSectionBanner,
    id: "CtaSectionBanner",
    category: "CtaSection",
    presets: ["Default"]
  }
];
const sectionsWithDataProps = [
  "BlogSectionTextImage",
  "CardSectionSmallBlocks",
  "ContentSectionSeo",
  "FeatureSectionBanner",
  "FeatureSectionBullets",
  "VideoSectionTabs",
  "ContentSectionFootnote",
  "CtaSectionBanner",
  "FeatureSectionBannerVariation",
  "FeatureSectionBenefits",
  "FeatureSectionPartners",
  "HeroSectionBanner"
];
export {
  FeatureSectionPoints,
  FeatureSectionSimpleListVariation,
  HeroSection,
  ContentSectionFootnote,
  CtaSectionBanner,
  FeatureSectionBannerVariation,
  FeatureSectionBenefits,
  FeatureSectionPartners,
  FeatureSectionSimpleListBackground,
  FeatureSectionVideoTabs,
  HeroSectionBanner,
  ContentSectionSeo,
  VideoSectionTabs,
  CardSectionCategories,
  FeatureSectionBanner,
  FeatureSectionBullets,
  FeatureSectionCarouselButton,
  FeatureSectionSmallBanners,
  FeatureSectionImagesGrid,
  CardSectionSmallBlocks,
  BlogSectionTextImage,
  ContentSectionTips,
  BlogSectionSimple,
  CardSectionApps,
  CardSectionAwards,
  CardSectionCatalog,
  CardSectionFlags,
  CardSectionGrid,
  CardSectionShops,
  CardSectionSimple,
  DocumentSectionSimple,
  FaqSectionSimple,
  LogoCloudSectionSimple,
  LogoCloudSectionWithFeatures,
  TeamSectionSimple,
  TestimonialSectionSlider,
  VideoSectionSimple,
  FeatureSectionArticles,
  FeatureSectionCarousel,
  FeatureSectionColumns,
  FeatureSectionInfoBlocks,
  FeatureSectionRecommended,
  FeatureSectionSimple,
  FeatureSectionSimpleList,
  FeatureSectionTextImage,
  HeaderSectionBackground,
  HeaderSectionImage,
  HeaderSectionSimple,
  HeaderSectionWithBanner,
  componentsWithDetails,
  sectionsWithDataProps
};
